import { render, staticRenderFns } from "./SalabamVadobay.vue?vue&type=template&id=2503a75e&scoped=true"
import script from "./SalabamVadobay.vue?vue&type=script&lang=js"
export * from "./SalabamVadobay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2503a75e",
  null
  
)

export default component.exports